<template>
<section class="vpn-section extra">
  <div class="vpn-section__inner extra__inner">
    <div class="extra__media">
      <img src="@/assets/vpn/extra-features.png" alt="Secure VPN servers map" loading="lazy" width="738" height="533">
    </div>
    <div class="extra__copy">
      <h2>{{ extraTitle }}</h2>
      <ul>
        <li v-for="item in extraItems" :key="item">
          <span class="extra__check" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M9.5 16.2 5.8 12.5l1.4-1.4 2.3 2.3 7.3-7.3 1.4 1.4z"/></svg>
          </span>
          {{ item }}
        </li>
      </ul>
      <a class="vpn-btn vpn-btn--primary" href="/download/" @click.prevent="goDownload">{{ extraCta }}</a>
      <p class="extra__play">
        {{ extraPlayPrefix }}
        <a :href="playStoreUrl" target="_blank" rel="noopener noreferrer">Google Play</a>
      </p>
    </div>
  </div>
</section>
</template>

<script>
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.secure.vpn.private.browser&referrer=utm_source%3Dweb'

import homeLocaleContent from '@/mixins/homeLocaleContent';

export default {
  name: 'ExtraFeaturesSection',
  mixins: [homeLocaleContent],
  computed: {
    extraTitle() {
      return this.homeLocale?.extraTitle || 'More Reasons to Use Secure VPN';
    },
    extraItems() {
      return this.homeLocale?.extraItems || this.defaultItems;
    },
    extraCta() {
      return this.homeLocale?.extraCta || 'Try Secure VPN';
    },
    extraPlayPrefix() {
      return this.homeLocale?.extraPlayPrefix || 'Download from';
    },
  },
  data() {
    return {
      playStoreUrl: PLAY_STORE_URL,
      defaultItems: [
        'Global server locations available',
        'Multi-device support',
        'Works with popular streaming platforms',
        'High-speed VPN connections',
        'Advanced privacy features',
      ],
    }
  },
  methods: {
    goDownload() {
      this.$router.push('/download/').catch(() => {
        window.location.assign('/download/')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.extra__inner {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 48px;
  align-items: center;
}

.extra__media img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 20px;
  box-shadow: var(--vpn-shadow, 0 12px 40px rgba(109, 74, 255, 0.12));
}

.extra__copy {
  h2 {
    margin: 0 0 32px;
    font-size: clamp(26px, 3.2vw, 36px);
    color: var(--vpn-ink, #1f2430);
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }

  ul {
    list-style: none;
    margin: 0 0 28px;
    padding: 0;
  }

  li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 12px;
    color: var(--vpn-ink, #1f2430);
    font-size: 16px;
    font-weight: 500;
  }
}

.extra__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(109, 74, 255, 0.12);
  color: var(--vpn-brand, #6d4aff);
  flex-shrink: 0;
  margin-top: 1px;
}

.extra__play {
  margin: 14px 0 0;
  font-size: 14px;
  color: var(--vpn-ink-muted, #5b6475);

  a {
    color: var(--vpn-brand, #6d4aff);
    font-weight: 600;
  }
}

@media (max-width: 900px) {
  .extra__inner {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .extra__copy {
    h2 {
      margin-bottom: 20px;
      font-size: clamp(22px, 6vw, 30px);
    }

    ul {
      margin-bottom: 20px;
    }

    li {
      font-size: 14.5px;
    }
  }
}

@media (max-width: 560px) {
  .extra__media img {
    border-radius: 14px;
  }
}
</style>
